import Vue from 'vue'
import Vuex from 'vuex'
import Http from 'vue-resource'

import { utils } from '@/libs/utils'
import { bus } from '@/libs/bus'
Vue.use(Vuex);
Vue.use(Http);

import debug from "debug";
var store_debug = debug("esma:store");

var server_url = "/api"
store_debug("TESTING STORE ", server_url )

var copy_allowed = function(allowed,data){
    var ret = {}
    var i = 0
    for(var d  in data){
        if(allowed.indexOf(d) > -1){
            ret[d] = data[d];
            i++;
        }
    }
    if(i == 0){
        ret = false
    }
    return ret
}

export const store = new Vuex.Store({
    state: {
        mdm_list:false,

        is_editing_batch:false,
        logged_user:"",
        show_message_after_login:true,
        server_url:server_url,
        row_data: [],

        is_editing_new:false,
        current_row:{},
        current_field_style:{},
        current_editing:[],
        last_filter_options:{},

        current_row2:{},
        current_field_style2:{},
        is_editing_new2:false,
        current_editing2:[],
        last_filter_options2:{},

        current_row3:{},
        current_field_style3:{},
        is_editing_new3:false,
        current_editing3:[],
        last_filter_options3:{},

        last_filter_options_history:{},

        notify_about_data_updated:0, // When increment it, it will generate an computed event
        last_save_result:false,
        table_notes:[],
        last_notify_event:{event_time:0,type:"undefined"},
        last_notify_event_sequence: 0,

        search_dependency_groups:{},
        search_data:{},

        cached_lists:[],
        define_department_limit:false
    },
    mutations:{
        onAllNoteLoadedData(state, data) {
                state.table_notes = data
        },
        onOneNoteLoadedData(state, data){
            var len = state.table_notes.length
            for (var i = 0; i < len; i++) {
                if (state.table_notes[i].seq_id == data.seq_id) {
                    store_debug("YES, set", state.table_notes[i].message, data.message)
                    for (var key in data) {
                        if (data[key] != state.table_notes[i][key]) {
                            state.table_notes[i][key] = data[key]
                        }
                    }
                }
            }
            state.current_row = data
        },
        OnLoadedData(state,data){
            if(data.success){
                state.row_data = data.data
            }else{
                state.row_data = []

            }
        },
        OnLoadedDataOneRow(state,data){
            if(data.success){
                 var id = data.data.id
                 var len = state.row_data.length;
                 for(var i =0; i< len;i++){
                     if(state.row_data[i].id == id){
                         for(var key in data.data){
                             if(data.data[key] != state.row_data[i][key]){
                                state.row_data[i][key] = data.data[key]
                             }  
                         }
                     }
                 }
                 state.notify_about_data_updated = (new Date()).getTime()
            }else{
                state.notify_about_data_updated = (new Date()).getTime()
            }

        },
        StoreNotify(state,ev_data ){
            ev_data.event_time = (new Date()).getTime()
            bus.$emit(ev_data.type,ev_data)
        },
        OnSuccess(state,data ){
            state.last_save_result = {success:true,type:data.type}
            state.notify_about_data_updated = (new Date()).getTime()
        },
        OnError(state,data ){
            state.last_save_result = {success:false,message:data.message,type:data.type}
            state.notify_about_data_updated = (new Date()).getTime()
        },
    },
    actions:{
        setOneNote(context,data){
            context.commit('onOneNoteLoadedData', data);
        },
        setAllNote(context, data) {
            context.commit('onAllNoteLoadedData', data);
        },
        makeLogin(context,data){
            Vue.http.post(server_url + '/login',{
                user_name: utils.Base64.encode(data.user_name),
                pass: utils.Base64.encode(data.pass)
            },[{method:"POST"}]).then(response => {
                if(response.body.success == true){
                    context.commit('StoreNotify', {type:"Login",success:true})
                }else{
                    context.commit('StoreNotify', {type:"Login",success:false,error:response.body.error})
                }
            }, response => {
                context.commit('StoreNotify', {type:"Login",success:false,error:"Error to access API"})
            });
        },
         makeLogout(context,data){
            Vue.http.post(server_url + '/logout',{},[{method:"POST"}])
            .then(response => {
                if(response.body.success == true){
                    context.commit('StoreNotify', {type:"Logout",success:true})
                }else{
                    context.commit('StoreNotify', {type:"Logout",success:false,error:response.body.error})
                }
            }, response => {
                context.commit('StoreNotify', {type:"Logout",success:false,error:"Error to access API"})
            });
        },
        getApplePassword(context,data){
             Vue.http.post(server_url + '/master/apple_pw',{
                    user_pass:data.userPassword,
                    serial:data.serial
                },[{method:"POST"}]).then(response => {
                    if(response.body.success == true){
                        context.commit('StoreNotify', {type:"ApplePassword",success:true,password:response.body.apple_pw})
                    }else{
                        context.commit('StoreNotify', {type:"ApplePassword",success:false,error:response.body.error})
                    }
                }, response => {
                    context.commit('StoreNotify', {type:"ApplePassword",success:false,error:"Error to access API"})
                });
        },
        getPage1Data(context) {
        },
        getPage2Data(context) {
        },
        getPage3Data(context) {
             Vue.http.get(server_url + '/list').then(response => {
                context.commit('OnLoadedData', response.data);
                context.commit('OnSuccess', {type:"loaded"})
            }, response => {
                context.commit('OnError', {type:"loaded",message:"データの読込に失敗しました。"})
                context.commit('OnLoadedData', {success : false});
            });
        },
        saveInfo(context,details) {
            var changes = false;

            if(changes == false){
                return context.commit('OnError', {message:"No changes to be saved.",type:"save"})
            }
            if(changes != false){
                Vue.http.post(server_url + '/save',{
                    page:details.page,
                    mode:details.mode,
                    changes,
                    seq_id:context.state.current_row.seq_id

                },[{
                    method:"POST"
                }]).then(response => {

                    if(response.body.success == true){

                        context.commit('OnLoadedDataOneRow', response.body)
                        context.commit('OnSuccess', {type:"save"})
                    }else{
                        context.commit('OnError', {message:"Unknown data base error",type:"save"})
                    }
                }, response => {
                    context.commit('OnError', {message:"Unknown data base error",type:"save"})
                });
            }
        }

    },
    getters: {

    },
    // mutations, when use , don call , but call commit, where type:"name of mutation", secondParam:"new value" (but it seems can use first param, second param too)
    // actions, when use actions, need to use dispatch instead of action, then the same as mutations
    // Can aslo separate then , see, https://www.youtube.com/watch?v=5z8joUGkGKE&index=2&list=PL55RiY5tL51pT0DNJraU93FhMzhXxtDAo#t=287.597686 aend of viepd
});


// WEBPACK FOOTER //
// ./src/store/store.js